module.exports = __webpack_public_path__ + "static/media/Ellipse 18.b9ab4eeb.png";